import React, { useState } from 'react'
import { Button, CircularProgress } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { useAppToast } from '@ui-seeker/app'
import { tableData, filterDateFrom, filterDateTo } from './@signals'

export default function ExportButton() {
    const [isExporting, setIsExporting] = useState(false)
    const { showToast } = useAppToast()

    const handleExport = () => {
        setIsExporting(true)

        try {
            const data = tableData.value

            if (!data || data.length === 0) {
                showToast.warning('No data to export')
                setIsExporting(false)
                return
            }

            // Build CSV content
            const headers = [
                'User',
                'Type',
                'Total Actions',
                'MAP',
                'UNMAP',
                'Hours Worked',
                'Rate/Hour'
            ]

            const rows = data.map(user => [
                user.user_email || 'Unknown',
                user.is_system ? 'System' : 'Human',
                user.total_actions || 0,
                user.map_count || 0,
                user.unmap_count || 0,
                user.hours_worked || 0,
                user.rate_per_hour?.toFixed(2) || 0
            ])

            const csvContent = [
                headers.join(','),
                ...rows.map(row => row.map(cell =>
                    typeof cell === 'string' && cell.includes(',')
                        ? `"${cell}"`
                        : cell
                ).join(','))
            ].join('\n')

            // Download the file
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url

            // Generate filename with date range info
            const dateFrom = filterDateFrom.value || 'all'
            const dateTo = filterDateTo.value || 'all'
            const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '')
            a.download = `user_stats_${dateFrom}_to_${dateTo}_${timestamp}.csv`

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url)

            showToast.success('Export completed')
        } catch (error) {
            console.error('Export error:', error)
            showToast.error('Failed to export data')
        } finally {
            setIsExporting(false)
        }
    }

    return (
        <Button
            variant="outlined"
            size="small"
            onClick={handleExport}
            disabled={isExporting}
            startIcon={isExporting ? <CircularProgress size={16} /> : <IconSeeker icon="download" size="sm" />}
        >
            Export CSV
        </Button>
    )
}
